import { render, staticRenderFns } from "./MenuToggle.vue?vue&type=template&id=1ff10697&scoped=true"
import script from "./MenuToggle.vue?vue&type=script&lang=js"
export * from "./MenuToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff10697",
  null
  
)

export default component.exports